

import { defineComponent, PropType } from 'vue';
import { Tournament } from '@/views/interfaces/entities.ts';
import { defaultPlayer } from '@/views/interfaces/entities.ts';

export default defineComponent({
    name: 'tournament-card',
    props: {
        tournament: {
            type: Object as PropType<Tournament>,
            required: true,
        },
    },
    data(){
        return {
            player: defaultPlayer,
            round_text:['Final', 'Semifinal', 'First Round']
        }
    },
    computed:{
        endDate(): Date {
            const timestamp = this.tournament.endMatch * 1000;
            return new Date(timestamp);
        },
        round(): string {
            const { currentRound, totalRounds } = this.tournament;
            const index = totalRounds - currentRound;
            return this.round_text[index];
        }
    }

});
